import { render } from "./myjrCreate.vue?vue&type=template&id=66d895e4"
import script from "./myjrCreate.vue?vue&type=script&lang=js"
export * from "./myjrCreate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__